import React from "react";
import {Button, Modal} from "react-bootstrap";
import {useMutation} from "react-query";
import {refundPaymentOrder} from "Api/Mutation/PaymentOrderMutation";
import {Notificator} from "Services/Notificator/Notificator";
import {MoneyAmount} from "Components/Money/MoneyAmount";

interface Props {
    show: boolean,
    transaction: any,
    onClose: () => void,
    onRefunded: () => void
}

export const RefundConfirmationModal: React.FC<Props> = (props) => {

    const refund = useMutation({
        mutationKey: ['refundPaymentOrder'],
        mutationFn: (id: string) => refundPaymentOrder(id),
        onSuccess: () => {
            Notificator.success('La devolución se ha realizado correctamente.')
            props.onRefunded()
            props.onClose()
        },
        onError: (response: any) => {
            const message = response.response?.data?._error?.message
                ? ('Error: ' + response.response.data._error.message)
                : 'Se ha producido un error al realizar la devolución.'
            Notificator.error(message)
        }
    })

    const confirm = () => {
        refund.mutate(props.transaction.id)
    }

    return (
        <Modal show={props.show} onHide={props.onClose}>
            <Modal.Header closeButton>
                <Modal.Title>CONFIRMAR DEVOLUCIÓN</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                {props.transaction &&
                    <p>
                        ¿Deseas realizar la devolución de{' '}
                        <strong><MoneyAmount amount={props.transaction.amount}/></strong>
                        {props.transaction.bankDsOrder && <> de la transacción con referencia{' '}
                            <strong>{props.transaction.bankDsOrder}</strong></>}?
                    </p>
                }
            </Modal.Body>

            <Modal.Footer>
                <Button
                    variant="secondary"
                    onClick={props.onClose}
                    disabled={refund.isLoading}
                >Cancelar</Button>
                <Button
                    variant="danger"
                    onClick={confirm}
                    disabled={refund.isLoading}
                >
                    {refund.isLoading ? 'Procesando...' : 'Confirmar devolución'}
                </Button>
            </Modal.Footer>
        </Modal>
    )
}
